export function dataInRequest(params = {}) {
  return {
    type: '@msgtcaPosto/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@msgtcaPosto/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@msgtcaPosto/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@msgtcaPosto/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@msgtcaPosto/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@msgtcaPosto/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@msgtcaPosto/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@msgtcaPosto/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@msgtcaPosto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@msgtcaPosto/RECORD_FILTERING',
    payload: { params },
  };
}
